import ticketRequest from "../requests/ticketRequest";
import { fileDownload } from "./fileDownload";
import { requestError } from "./requestError";

/**
 * Downloads the documents of a basket.
 *
 * @param basketId The id of the basket.
 * @param sessionExpiredDispatcher Callback function to be called on a 401 error.
 * @param loginStateDispatcher Callback function to be called on a 401 error.
 * @returns {function(): void}
 */
export default function downloadBasket(
  basketId,
  sessionExpiredDispatcher,
  loginStateDispatcher
) {
  return () => {
    ticketRequest()
      .then(response => {
        const ticket = response.data.ticket;
        const path = `api/baskets/${basketId}/download?ticket=${ticket}`;
        fileDownload(path);
      })
      .catch(requestError(sessionExpiredDispatcher, loginStateDispatcher));
  };
}
